import React from "react";
import { FormProvider } from "react-hook-form";
import { Box } from "@mui/material";

import "./edit-text.scss";
import { RFHTextField } from "../../../../../../components/RFH";
import { useDetailTitleState } from "./hooks/useDetailTitleState";

function EditTitle({ title, cardId, hasEditCardPermission, id }) {
  const {
    detailTitle,
    formMethods,
    handleKeyDown,
    handleSubmitTitle,
    isMobile,
    open,
    openField,
  } = useDetailTitleState({
    boardId: id,
    cardId,
    hasEditCardPermission,
    title,
  });

  return (
    <>
      {open && hasEditCardPermission ? (
        <>
          <FormProvider {...formMethods}>
            <Box
              component="form"
              onSubmit={handleSubmitTitle}
              noValidate
              className="edit-board-field-name"
              onBlur={handleSubmitTitle}
              onKeyDown={handleKeyDown}>
              <RFHTextField
                className="edit-text edit-text-title-field"
                required
                fullWidth
                multiline
                size="small"
                id="title"
                name="title"
                defaultPadding={false}
                autoFocus
              />
            </Box>
          </FormProvider>
        </>
      ) : (
        <p
          className={isMobile ? "mobile-edit-text" : "edit-text"}
          onClick={openField}>
          {detailTitle}
        </p>
      )}
    </>
  );
}

export default React.memo(EditTitle);
